import React from 'react';
import {
    Button,
} from "antd";
import {setLoggedInUser} from '../../API/Cookie';
import logo from '../../assets/images/logo.png'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faDownload, faSignOut} from '@fortawesome/free-solid-svg-icons';
import {Link} from 'react-router-dom';
import Success from '../../assets/success.gif';
import Navbar from '../../components/layout/Navbar';
import Footer2 from '../../components/layout/Footer2';

const ConsentSuccess = () => {
    return (
        <>
        <div className='consent-main'>
            <div className='topbar' style={{zIndex: 1}}>
            <Navbar />
                <Button
                    // type="primary"
                    className='consent-button-signout'
                    style={{
                        width: "150px",
                        backgroundColor: 'transparent',
                        color: '#fff',
                        border: 'none',
                        backgroundImage: 'linear-gradient(-270deg, rgba(0, 150, 119, 1) 0%, rgba(80, 184, 72, 1) 100%)',
                        height: '60px',
                        borderRadius: 0
                    }}
                    onClick={(e) => {
                        e.preventDefault();
                        setLoggedInUser();
                        localStorage.removeItem('UserData');
                        window.location.href = "/";
                    }}
                >
                    Sign Out
                    <FontAwesomeIcon icon={faSignOut} style={{marginLeft: 10}} />
                </Button>
            </div>
            <div className='consent-selector'>

                <h1>
                    Consent Updated Successfully
                </h1>


            </div>
            <div className="consent-container" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <img src={Success} />
                <p style={{color: '#000', textAlign: 'center'}}>
                    Thank you for giving your consent to the processing of your personal data
                    you can come back to update your consent at any time using this platform.
                </p>
                <div style={{width: 200, display: 'flex', justifyContent: 'space-around'}}>
                    <Button
                        onClick={(e) => {
                            e.preventDefault();
                            setLoggedInUser();
                            localStorage.removeItem('UserData');
                            window.location.href = "/";

                        }}
                    >
                        Sign Out
                    </Button>
                    <Link to="/">
                        <Button>
                            Submit Again
                        </Button>
                    </Link>
                </div>

            </div>
        </div>
        <br/>
        <br/>
        <Footer2 />  
        </>     

    )
}

export default ConsentSuccess